import { capitalDesignTokens, createTypedSxStyles } from "@opengov/capital-mui-theme";

export const styles = createTypedSxStyles({
  container: {
    backgroundColor: capitalDesignTokens.semanticColors.background.primary,
    borderBottom: `1px solid ${capitalDesignTokens.semanticColors.border.secondary}`,
    marginBottom: "24px",
    paddingLeft: "24px",
    paddingRight: "24px",
    "& .MuiTabs-flexContainer": {
      gap: "8px",
    },
    "& .MuiTab-root": {
      margin: "0px",
      paddingLeft: "8px",
      paddingRight: "8px",
      minWidth: 0,
      textTransform: "none",
      color: capitalDesignTokens.semanticColors.foreground.primary,
      fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold,
    },
    "& .MuiTab-root.Mui-selected": {
      color: capitalDesignTokens.semanticColors.foreground.action,
      fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold,
    },
    "& .MuiTabs-indicator": {
      backgroundColor: capitalDesignTokens.semanticColors.foreground.action,
    },
  },
});
